<template>
  <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab-3">
    <!--     Basic Settings Templates -->
    <templates-modal/>

    <!--   Save  Basic Settings Templates -->
    <save-settings-template :params="paramsGroup"/>

    <edit-template-modal
      :is_import="is_import"
    />


    <div class="form-row">
      <div class="col-md-12">
        <div class="innerbox pb-2">
          <div class="row">
            <form class="w-100" ref="groups_form" v-on:submit.prevent="saveProjectDetails">
              <div class="col-md-8">
                <h4 class="ml-2 border-bottom font-weight-bold" style="padding-bottom: 18px">Schlagworte
                  <span class="float-right">
<!--                    <button type="button" style="padding: 6px 13px" data-toggle="modal" data-target="#templateModal" class="arrows-btns add-group-btn d-inline-block" v-if="paramsGroup.length < 1">-->
<!--                      <i class="fa fa-caret-square-o-left" aria-hidden="true"></i>-->
<!--                      Vorlage wählen-->
<!--                    </button>-->
                    <button type="button" class="arrows-btns add-group-btn m-0 d-inline-block" style="padding: 6px 13px" data-toggle="modal" data-target="#saveTemplateModal">
                      <!--
                      <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                      -->
                      Als Vorlage speichern
                    </button>
                    <button type="button" class="arrows-btns add-group-btn m-0 d-inline-block" style="padding: 6px 13px" data-toggle="modal" data-target="#editTemplateModal">

                      <!--
                      <i class="fa fa-edit mr-1" aria-hidden="true"></i>
                      -->

                      Vorlagen öffnen
                    </button>
                  </span>
                </h4>
                <div class="inrbox pb-1 screen-height catch-words pl-0">
                  <div class="col-md-12 pl-2">
                    <table class="table table-sm">
                      <thead>
                      <tr>
                        <th scope="col">
                        <div class="pl-1"> Schlagwortgruppe</div>
                        </th>
                        <th scope="col">Schlagwort</th>
                        <th scope="col">Typ</th>
                        <th scope="col">
                          <span class="d-none">{{count = 1}}</span>
                        </th>
                      </tr>
                      </thead>
                      <tbody v-for="(group, i) in paramsGroup" :key="i" class="border-0">
<!--                      <tbody v-for="(group, i) in groupedParams" :key="i" class="border-0">-->
                      <tr @click="makeGroupEditable($event,i)" :class="{active_tr: activeGroup === i}" data-value="btn">
                        <td colspan="3">
                          <div class="form-row">
                            <!--                      <i class="fa fa-circle dot-color pt-2 mt-1 d-inline"></i>-->
                            <div class="custom-control pl-2 mt-1 custom-checkbox circle-checkbox d-inline" data-value="btn">
                              <input type="text" :value="group.groupName" @change="changeGroupName($event, i)" class="group-input form-control input-style" v-if="activeGroup === i || group.items[0].isNew" placeholder="Schlagwortgruppenname" data-value="btn" required autofocus>
                              <input v-else type="text" :value="group.groupName" @change="changeGroupName($event, i)" class="group-input form-control input-style bg-white border-0" placeholder="Schlagwortgruppenname"  readonly>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="udarrow mr-0" v-visible="i === activeGroup" style="width: 4.5rem">
                            <div @click="moveGroupUp(i)" data-value="btn" class="d-inline-block arrows-btns" v-if="i">
                              <i class="fa fa-angle-up"></i>
                            </div>
                            <div @click="moveGroupDown(i)" data-value="btn" class="d-inline-block arrows-btns" v-if="groupedParams.length !== (i + 1)">
                              <i class="fa fa-angle-down"></i>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr v-for="(keyword , index) in group.items" :key="keyword.projectparamid" :class="{active_tr : `${index}${i}` === activeItem}" @click="makeFieldsEditable($event,`${index}${i}`)">
                        <th scope="row">
                          <!--                    {{ keyword.order }}-->
                        </th>
                        <td>
                          <div class="form-row">
                            <div class="col-auto">
                              <!--                        <div class="custom-control pl-0 custom-checkbox circle-checkbox" data-value="btn">-->
                              <!--                          <i class="fa fa-circle dot-color pt-1"></i>-->
                              <!--                        </div>-->
                            </div>
                            <div class="col-auto">
                              <input type="text" v-if="`${index}${i}` === activeItem" v-model="keyword.name" class="form-control input-style" data-value="btn" required>
                              <input type="text" v-else v-model="keyword.name" class="form-control input-style" readonly required>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="form-row justify-content-center">
                            <div class="switch-toggle switch-3 switch-candy" data-value="btn">
                              <input data-value="btn" :id="`ond${index}${i}`" :name="`state-d${index}${i}`" type="radio" v-model="keyword.type" value="0"/>
                              <label data-value="btn" :for="`ond${index}${i}`" class="arrows-btns">
                                <i class="fa fa-check" data-value="btn" aria-hidden="true"></i>
                              </label>
                              <input :id="`of${index}${i}`" :name="`state-d${index}${i}`" v-model="keyword.type" value="1" data-value="btn" type="radio"/>
                              <label data-value="btn" class="arrows-btns btn-abc" :for="`of${index}${i}`">ABC</label>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="udarrow mr-0" v-visible="`${index}${i}` === activeItem" style="width: 4.5rem">
                            <div @click="moveUp(keyword.projectparamid , index,i)" v-if="index" data-value="btn" class="d-inline-block arrows-btns">
                              <i class="fa fa-angle-up" data-value="btn"></i>
                            </div>
                            <div @click="moveDown(keyword.projectparamid ,index , i)" v-if="group.items.length !== (index + 1)" data-value="btn" class="d-inline-block arrows-btns">
                              <i class="fa fa-angle-down" data-value="btn"></i>
                            </div>
                          </div>
                          <a @click="removeKeyword(keyword.projectparamid, i , index)" class="d-inline-block arrows-btns" data-value="btn" v-visible="`${index}${i}` === activeItem">
                            <i class="fa fa-trash-alt" data-value="btn"></i>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td colspan="3" class="text-left">
                          <button type="button" class="arrows-btns add-group-btn" @click="addNewFieldInTagsGroup(group.groupName , i)">
                            <i class="fa fa-plus pr-1" aria-hidden="true"></i>
                            Feld hinzufügen
                          </button>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <td colspan="2" class="text-left">
                          <button type="button" class="arrows-btns add-group-btn mt-1" @click="addNewGroup">
                            <i class="fa fa-plus pr-1" aria-hidden="true"></i>
                            Gruppe hinzufügen
                          </button>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="dokubtns pt-3">
                  <span class="btninner float-right">
                    <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$router.push({name: 'photo', params: {id: $route.params.id}})">
                      Abbrechen
                    </button>
                    <button type="submit" class="btn btn-blue">
                      Speichern
                    </button>
                  </span>
                  <div class="clearfix"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplatesModal from './TemplatesModal'
import SaveSettingsTemplate from './SaveSettingsTemplate'
import EditTemplateModal from "./EditTemplateModal.vue";
// import axios from 'axios'
import axios from '../../../utils/axiosinstance'
export default {
  components: {TemplatesModal, SaveSettingsTemplate, EditTemplateModal},
  name: 'catchwords',
  data () {
    return {
      num: 0,
      activeTr: null,
      is_import: false,
      activeGroup: null,
      activeItem: null,
      groupCount: 0,
      count: 1
    }
  },
  computed: {
    project () {
      return this.$store.state.appSettings.project
    },
    paramsGroup () {
      // return this.$store.state.project.paramsGroup
      return this.$store.state.appSettings.paramsGroup
    },
    params: {
      get () {
        return this.$store.state.appSettings.project.params || []
      }, set (val) {
        this.$store.commit('setProjectParams', val)
      }
    },

    groupedParams () {
      const grouped = this.params.reduce(
        (entryMap, e ) =>  entryMap.set(e.group, [...entryMap.get(e.group) || [], e]), new Map())
        let v = Array.from(grouped, ([groupName, items]) => ({groupName, items}))
        this.$store.state.appSettings.paramsGroup = v
        return v;
    }
  },
  methods: {
    async saveProjectDetails () {
      let params = []
      let count = 0
      this.paramsGroup.forEach(group => {
        group.items.forEach(item => {
          if (item.projectparamid && item.projectparamid.startsWith('new')) {
            delete item.projectparamid
          }
          item.order = ++count
          params.push(item)
        })
      });
      params = this.getUniqueArray(params);
      await this.$store.commit('setProjectParams', params)
      await this.$store.dispatch('updateProjectDetails')
      await this.$router.push({name: 'photo', params: {id: this.$route.params.id}})
    },
    getUniqueArray(array) {
      // Filter out items with null or empty names
      const validItems = array.filter(item => item.name && item.name.trim() !== '');

      const uniqueItems = [];
      const seenNamesInGroups = {};
      let order = 1;
      validItems.forEach(item => {
        // Initialize a set for the group if it doesn't exist
        if (!seenNamesInGroups[item.group]) {
          seenNamesInGroups[item.group] = new Set();
        }
        const itemNameLower = item.name.toLowerCase();
        if (!seenNamesInGroups[item.group].has(itemNameLower)) {
          seenNamesInGroups[item.group].add(itemNameLower);
          item.order = order++;
          uniqueItems.push(item);
        }
      });
      return uniqueItems;
    },

    async  deleteGroupItem(id){
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "deleteProjectparam",
          "parameters": [id],
          "serviceName": "ProjectdocuService"
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
          console.log(res,"response")
      })
    },


    /** On click on a row make it editable
     *
     * @param e
     * @param index
     */
    makeFieldsEditable (e, index) {
      let element = e.target.getAttribute('data-value')
      console.log(element,"here it is",e.target)
      if (element !== 'btn' && e.target.tagName !== 'IMG') {
        this.activeItem = this.activeItem === index ? null : index
        this.activeGroup = null
      }
    },

    //On click a table row make it group name editable
    makeGroupEditable (e, index) {
      let element = e.target.getAttribute('data-value')
      let tag = e.target.tagName
      if ((element !== 'btn' && tag !== 'IMG')) {
        this.activeGroup = this.activeGroup === index ? null : index
        this.activeTr = null
      }
    },

    //remove group
    removeGroup (name) {
      this.params = this.params.filter(item => item.group !== name)
    },

    // Move the Keyword field Up one step by clicking the Up arrow
    moveUp (id, index, i) {
      let from = index
      let to = from - 1
      const elm = this.paramsGroup[i].items.splice(from, 1)[0]
      this.paramsGroup[i].items.splice(to, 0, elm)
      this.activeItem = `${index - 1}${i}`
    },

    /**Move the Keyword field down by clicking the down arrow
     *
     * @param id
     * @param index
     * @param i
     */
    moveDown (id, index, i) {
      let from = index
      let to = from + 1
      const elm = this.paramsGroup[i].items.splice(from, 1)[0]
      this.paramsGroup[i].items.splice(to, 0, elm)
      this.activeItem = `${index + 1}${i}`
    },

   async moveGroupUp (from) {
      let to = from - 1
      const elm = this.paramsGroup.splice(from, 1)[0]
      await this.paramsGroup.splice(to, 0, elm)
      this.activeGroup = from - 1
    },

    moveGroupDown (from) {
      let to = from + 1
      const elm = this.paramsGroup.splice(from, 1)[0]
      this.paramsGroup.splice(to, 0, elm)
      this.activeGroup = to
    },

    moveIndex (from, to) {
      let numberOfDeletedElm = 1
      const elm = this.params.splice(from, numberOfDeletedElm)[0]
      numberOfDeletedElm = 0
      this.params.splice(to, numberOfDeletedElm, elm)
    },

    //function to remove Group item
   async removeKeyword (id , i , index) {
      let _this = this
      if (id && id.startsWith('new')){
        this.paramsGroup[i].items.length  === 1 ? this.paramsGroup.splice(i, 1) :this.paramsGroup[i].items.splice(index, 1);
      }else {
        _this.$confirm({
          message: "Schlagwort löschen?",
          button: {
            no: 'Abbrechen',
            yes: 'Ja'
          }, callback: confirm => {
            if (confirm) {
              _this.$store.commit('settingsModuleSetLoading',true);
              _this.deleteGroupItem(id);
              _this.paramsGroup[i].items.length  === 1 ? _this.paramsGroup.splice(i, 1) : _this.paramsGroup[i].items.splice(index, 1);
              _this.$store.commit('settingsModuleSetLoading',false);
              _this.$toast.success("Schlagwort gelöscht");
            }
          }
        });
      }
    },

    addNewFieldInTagsGroup (groupName , i) {
      let id = this.$route.params.id
      let newField =
        {
          group: groupName,
          isUsed: null,
          name: '',
          projectparamid: `new${Math.random()}`,
          order: '0',
          paramType: 'project',
          projectid: id,
          type: '0',
          value: null,
          visible: '0',
          _explicitType: 'com\\projectdocu\\ProjectparamVO'
        }
      this.paramsGroup[i].items.push(newField)
    },

    /**On Change Group Name
     *
     * @param e
     * @param index
     */
    changeGroupName (e, index) {
      let value = e.target.value
      this.paramsGroup[index].items.forEach(item => {
        item.group = value
      })
      this.paramsGroup[index].groupName = value
    },

    /**
     * Add New Group
     */
    addNewGroup () {
      let id = this.$route.params.id
      let name = ''
      if (this.groupCount === 0){ this.activeGroup = this.paramsGroup.length }
      let newGroup = {
        groupName: name,
        items: [{
          group: name,
          isUsed: null,
          name: '',
          isNew: true,
          order: '0',
          projectparamid: `new${Math.random()}`,
          paramType: 'project',
          projectid: id,
          type: '0',
          value: null,
          visible: '0',
          _explicitType: 'com\\projectdocu\\ProjectparamVO'
        }]
      }
      this.paramsGroup.push(newGroup)
      this.groupCount++
    }
  },
  watch: {
    '$store.state.appSettings.project.params': function() {
      console.log('paramsGroup Changes', this.$store.state.appSettings.paramsGroup)

      this.addNewGroup()

    },
    //
    // params: function (val) {
    //   let grouped = val.reduce(
    //     (entryMap, e ) =>  entryMap.set(e.group, [...entryMap.get(e.group) || [], e]), new Map())
    //   this.paramsGroup = Array.from(grouped, ([groupName, items]) => {
    //     let words = items.sort((a , b) => a.order - b.order)
    //     return {groupName: groupName ,  items: words}
    //   })
    // }
  }
}
</script>

<style scoped>
.active_tr {
  background: lightgray;
}

input.group-input {
  border: 1px solid #ccc;
  padding: 4px;
  width: 100%;
  border-radius: 3px;
  font-weight: bold;
}

.btnw, .udarrow small, .udrem {
  cursor: pointer;
  z-index: 1000;
  font-size: 1rem;
}

.switch-toggle input {
  width: fit-content;
}

.main-tabs .table-sm td {
  padding-top: 4px;
}

.switch-toggle input + label {
  z-index: 1000;
}

.switch-toggle input[type="radio"] + label {
  background: #ffffff;
}

.switch-toggle input[type="radio"]:checked + label {
  background: #3f97ef;
}

.circle-checkbox .custom-control-label {
  position: absolute;
}

button.btn-primary:hover {
  color: #3f97ef !important;
}
.inrbox.catch-words{
  height: calc(100vh - 249px);
}
.arrows-btns{
  color: gray;
  border-radius: 5px;
  margin-top: 2px;
  background-color: #FFFFFF;
  border: 1px solid #dcdcdc;
  padding: 1px 8px;
  font-size: 15px;
  cursor: pointer;
}
.btn-abc{
  padding: 4px 13px;
  font-size: 12px;
  font-weight: 600;
}
.add-group-btn{
  margin: 4px 0 4px 9px;
  padding: 3px 8px;
  font-size: 15px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/Catchwords.vue